import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { BaseDataService, HttpResponsesHandlersFactory, IHttpResponseHandlerSettings } from "@bbwt/modules/data-service";
import { IQueryCommand } from "@features/filter";
import { DatabaseMenuItem } from "./database-menu-item";
import { IPagedData } from "@features/grid";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { MainMenuService } from "./main-menu.service";

@Injectable({
    providedIn: "root"
})
export class DatabaseItemsService extends BaseDataService {
    readonly url = "api/menu/database-item";
    private broadcastService = inject(BroadcastService);

    constructor(http: HttpClient, httpResponseFactory: HttpResponsesHandlersFactory) {
        super(http, httpResponseFactory);
    }

    getPage(queryCommand: IQueryCommand, responseHandlerSettings?: IHttpResponseHandlerSettings) {
        return this.handleRequest(
            this.http.get<IPagedData<DatabaseMenuItem>>(`${this.url}/page`, { params: this.constructHttpParams(queryCommand) }),
            this.handlersFactory.getForReadByFilter(responseHandlerSettings)
        );
    }

    async delete(id: string) {
        await this.handleRequest(this.http.delete<void>(`${this.url}/${id}`));
        this.broadcastService.broadcast(MainMenuService.MainMenuChangedEventName);
    }

    async updateParent(id: string, parentId?: number) {
        const body = { id, parentId };
        await this.handleRequest(this.http.put(`${this.url}/${id}/parent`, body));
        this.broadcastService.broadcast(MainMenuService.MainMenuChangedEventName);
    }
}
